import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromUserGroup from './user-group.reducer';
import { UserGroupState } from './user-group.state';
import { GroupOfUser, Group } from '@era/security-sdk';
import { selectCurrentUserId } from '../router/security-router.selector';
import { selectAllGroups } from '../group/group.selector';

export const selectUserGroupState = createFeatureSelector<UserGroupState>('userGroups');

export const selectAllUserGroups = createSelector(selectUserGroupState, fromUserGroup.selectAllGroups);

export const selectGroupByParentId = (parentId: string) =>
  createSelector(selectAllUserGroups, (memberGroups: GroupOfUser[]) =>
    memberGroups ? memberGroups.filter((group) => group.userId === parentId) : []
  );

export const selectGroupNamesByParentId = (parentId: string) =>
  createSelector(selectAllUserGroups, (memberGroups: GroupOfUser[]) =>
    memberGroups ? memberGroups.filter((group) => group.userId === parentId).map((group) => group.name) : []
  );

export const selectGroupIdsByParentId = (parentId: string) =>
  createSelector(selectAllUserGroups, (memberGroups: GroupOfUser[]) =>
    memberGroups ? memberGroups.filter((group) => group.userId === parentId).map((group) => group.id) : []
  );

export const selectCurrentUserMemberships = createSelector(
  selectCurrentUserId,
  selectAllUserGroups,
  (currentUserId: string, userGroups: GroupOfUser[]) =>
    currentUserId && userGroups ? userGroups.filter((group) => group.userId === currentUserId) : []
);

export const selectUserMembership = (userId: string) =>
  createSelector(selectAllUserGroups, (userGroups: GroupOfUser[]) =>
    userId && userGroups ? userGroups.filter((group) => group.userId === userId) : []
  );

export const selectAllPossibleMemberships = createSelector(
  selectCurrentUserMemberships,
  selectAllGroups,
  (memberShips: GroupOfUser[], groups: Group[]) =>
    memberShips && groups
      ? groups.filter((group) => memberShips.filter((x) => x.inherited === false).every((y) => group.id !== y.id))
      : []
);
